import { Component, HostListener, TemplateRef } from '@angular/core';
import { CurrencyPipe, NgStyle } from '@angular/common';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { SiteService } from '@services/site.service';
import { ApiService } from '@services/api.service';
import { LoginComponent } from '../login/login.component';
import { Site } from '../../models/Site.model';
import { ModuleNamePipe } from '../../pipes/module-name.pipe';
import { ModuleImagePipe } from '../../pipes/module-image.pipe';
import { environment } from '@environments';
import { PdfViewerModule } from 'ng2-pdf-viewer';

declare const YT: any;

export interface Ranking {
  mechanic: string;
  week: string;
  start: string;
  end: string;
  prize: string;
  bases?: string;
  packs?: string;
}

@Component({
  selector: 'app-site',
  imports: [
    NgStyle,
    PdfViewerModule,
    CurrencyPipe,
    ModuleNamePipe,
    ModuleImagePipe,
  ],
  templateUrl: './site.component.html',
  styleUrl: './site.component.scss',
})
export class SiteComponent {
  active: number = -1;
  site: Site = new Site();
  domain: string = '';
  password: string = '';
  loaded: boolean = false;
  hasLogin: boolean = false;
  isMobile: boolean = false;
  ranking: Ranking[] = [];

  @HostListener('window:resize', ['$event'])
  onResize(_event: any) {
    this.setAppHeight();
  }

  private setAppHeight() {
    this.isMobile = window.innerWidth < 992;
  }

  constructor(
    private siteService: SiteService,
    private api: ApiService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.setAppHeight();
    // * IFRAME API
    const tag = document.createElement('script');

    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);
    // * IFRAME API

    const domain = sessionStorage.getItem(environment.storage + '-site');

    if (domain) {
      this.domain = domain;
      this.handleSiteData();
    } else {
      this.loaded = true;
    }
  }

  handleSiteData() {
    this.api.call(`api/site?domain=${this.domain}`).subscribe({
      next: (response) => {
        if (response.status === 200 && response.data) {
          this.hasLogin = this.siteService.setSiteData(response.data);
          this.site = response.data;

          if (this.site.password) {
            this.password = this.site.password;
          }

          const store = sessionStorage.getItem(
            environment.storage + '-site-store'
          );

          if (this.hasLogin) {
            this.handleLogin();
          } else {
            const ranking =
              this.site.modules.findIndex((module) => {
                return module.type === 'results';
              }) > -1;

            if (ranking && store) {
              this.loadRanking();
            } else {
              this.handleLogin();
            }
          }

          this.loaded = true;
        }

        this.loaded = true;
      },
      error: (error) => {
        console.error(error);
        this.loaded = true;
      },
    });
  }

  onYouTubeIframeAPIReady(video: string) {
    let player: any;

    player = new YT.Player('player', {
      height: '390',
      width: '640',
      videoId: this.youtubefy(video),
      playerVars: {
        playsinline: 1,
      },
      events: {
        onReady: this.onPlayerReady,
      },
    });
  }

  onPlayerReady(event: any) {
    event.target.playVideo();
  }

  open(content: TemplateRef<any>, index: number, video?: string) {
    this.active = index;

    const modalRef = this.modalService.open(content, {
      size: 'xl',
      scrollable: true,
      centered: true,
    });

    modalRef.shown.subscribe(() => {
      if (video) {
        this.onYouTubeIframeAPIReady(video);
      }
    });
  }

  handleLogin() {
    const modalRef = this.modalService.open(LoginComponent, {
      size: 'xl',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });

    modalRef.componentInstance.password = this.password;

    modalRef.result.then(
      (_result) => {
        this.loadRanking();
      },
      (_reason) => {
        this.loadRanking();
      }
    );
  }

  loadRanking() {
    const store = sessionStorage.getItem(environment.storage + '-site-store');

    if (store) {
      this.api
        .call(`api/results?domain=${this.domain}&store=${store}`)
        .subscribe({
          next: (response: any) => {
            if (response.status === 200 && response.data) {
              this.ranking = response.data;
            }
          },

          error: (error) => {
            console.error(error);
          },
        });
    }
  }

  youtubefy(value: string): string {
    const ytRegExp =
      /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=|shorts\/)|youtu\.be\/)([^"&?\/\s]{11})/gi;

    const match = ytRegExp.exec(value);

    if (match && match[1]) {
      return match[1];
    }

    return value;
  }
}
